export const main = {
  notice: 'Solutions de commande et de gestion pour les restaurants',
  notice_2: 'un site web ou une boutique en ligne pour votre restaurant en quelques minutes',

  logo_alt: 'Bistroo',
  login_text: 'Se connecter',
  login_text_mobile: 'Connexion restaurant',
  start_free_text: 'Accès gratuit',

  actions: {
    create_your_shop: 'Créer votre boutique',
    product_demo: 'Démo produit',
  },

  menu: {
    home: {
      text: 'Accueil',
    },
    products: {
      text: 'Produits',
      submenu: {
        manager: {
          text: 'Bistroo Manager',
          subtext: 'Tous les outils entièrement en autogestion',
        },
        qr: {
          text: 'Bistroo QR',
          subtext: 'Un processus de commande à table rentable',
        },
        webshop: {
          text: 'Bistroo Webshop',
          subtext: 'La boutique en ligne pour votre restaurant',
        },
        pos: {
          text: 'Bistroo Caisse',
          subtext: 'Caisse ultrarapide pour le service rapide',
        },
        posdevice: {
          text: 'Bistroo Device',
          subtext: 'Commande et impression plug & play',
        },
        page: {
          text: 'Bistroo Website',
          subtext: 'Créez un site web en quelques minutes',
        },
        kiosk: {
          text: 'Bistroo Kiosk',
          subtext: 'Libre-service dans votre restaurant',
        },
      },
    },
    prices: {
      text: 'Tarifs',
    },
    cases: {
      text: 'Cas clients',
      submenu: {
        cafetaria: {
          text: "Cafetaria D'n Boom",
          subtext: 'Comment Bistroo a aidé à augmenter le chiffre d\'affaires.',
        },
        grillroom: {
          text: 'Grillroom Instanbul',
          subtext: 'Enfin un modèle de revenus équitable.',
        },
        sushi: {
          text: 'Sushi De wethouder',
          subtext: 'Un partenaire en qui nous avons confiance 24h/24 et 7j/7.',
        },
        italian: {
          text: 'Italien Il Municipio',
          subtext: 'Une nouvelle solution et de nouvelles opportunités.',
        },
        lunchroom: {
          text: 'Lunchroom Two-B',
          subtext: 'Nous avons économisé beaucoup de temps et de frustrations.',
        },
      },
    },
    info: {
      text: 'Info',
      submenu: {
        helpcenter: {
          text: 'Centre d\'aide',
          subtext: 'Toutes les informations dont vous avez besoin',
        },
        integrations: {
          text: 'Intégrations',
          subtext: 'Nos intégrations partenaires',
        },
        downloads: {
          text: 'Téléchargements',
          subtext: 'Les dernières mises à jour de l\'application',
        },
        articles: {
          text: 'Articles',
          subtext: 'Dernières actualités du secteur',
        },
        faq: {
          text: 'FAQ',
          subtext: 'Questions fréquemment posées',
        },
        blog: {
          text: 'Blog',
          subtext: 'Infos actuelles & tendances',
        },
        support: {
          text: 'Service client',
          subtext: 'Nous sommes là pour vous aider',
        },
        contact: {
          text: 'Contact',
          subtext: 'Nous sommes là pour vous aider',
        },
      },
    },
  },
  cta_block: {
    open_your_webshop_today: 'Ouvrez votre boutique aujourd\'hui.',
    its_free: 'C\'est gratuit !',
    start_generating_more_orders: 'Générez votre première commande en quelques minutes',
    get_started_for_free: 'Démarrer gratuitement',
  },
  footer: {
    general: 'Général',
    products: 'Produits',
    cases: 'Cas clients',
    info: 'Informations',
  },
  product_faq: {
    label: 'Questions fréquemment posées',
    not_listed: 'Vous ne trouvez pas votre question ? Contactez notre équipe de support.',
  },
  integration: {
    back_link: 'Toutes les intégrations',
    advantages_label: 'Avantages',
    setup_label: 'Configurer en 5 étapes',
    faq_heading: 'Questions fréquemment posées',
    more_info: 'Plus d\'info',
    check_1: 'Sans engagement, résiliable mensuellement',
    check_2: 'Configuration en quelques minutes',
    advantages_subtitle: 'Des fonctionnalités puissantes qui fonctionnent ensemble pour vos opérations de restauration',
    cta_footer_text: 'Configuration en moins de 10 minutes · Annulation à tout moment',
    related: {
      eyebrow: 'Voir aussi',
      title: 'Intégrations connexes',
      description: 'Bistroo travaille avec les meilleurs outils. Combinez plusieurs intégrations pour une opération de restauration entièrement automatisée.',
    },
    cta: {
      heading: 'Ouvrez votre boutique aujourd\'hui.',
      free: 'Gratuit.',
      subtext: 'Plus de commandes, moins de travail.',
      button: 'Démarrer gratuitement',
    },
  },
}
